export function filterKeysByPrefix<T extends Record<string, unknown>, Prefix extends string>(
  data: T,
  prefix: Prefix,
) {
  return Object.fromEntries(Object.entries(data).filter(([key]) => key.startsWith(prefix))) as Pick<
    T,
    `${Prefix}${string}`
  >;
}
